import React from "react";
import TradeField from "./TradeField";
import { thisBaseURL } from "../../utils/helper.js";

function Trade({countryAnswers}){
	let defaultCountry = countryAnswers.answerKeyValues["country_code"];
	let tradeImportPartners = countryAnswers.answerKeyValues['top_trade_partners_imports'];
	let tradeImportArr = [];
	if(tradeImportPartners){
		try {
			tradeImportArr = JSON.parse(tradeImportPartners);
		} catch (err) {
			console.log("Trade :tradeImportPartners: " +err);
		}
	}
	let tradeExportPartners = countryAnswers.answerKeyValues['top_trade_partners_exports'];
	let tradeExportArr = [];
	if(tradeExportPartners){
		try {
			tradeExportArr = JSON.parse(tradeExportPartners);
		} catch (err) {
			console.log("Trade :tradeExportPartners: " +err);
		}
	}
	let topImportQty = countryAnswers.answerKeyValues['top_imports_quantity'];
	let topImportQtyArr = [];
	if(topImportQty){
		try {
			topImportQtyArr = JSON.parse(topImportQty);
		} catch (err) {
			console.log("Trade :topImportQty: " +err);
		}
	}
	let topImportVal = countryAnswers.answerKeyValues['top_imports_value'];
	let topImportValArr = [];
	if(topImportVal){
		try {
			topImportValArr = JSON.parse(topImportVal);
		} catch (err) {
			console.log("Trade :topImportVal: " +err);
		}
	}
	let topExportQty = countryAnswers.answerKeyValues['top_exports_quantity'];
	let topExportQtyArr = [];
	if(topExportQty){
		try {
			topExportQtyArr = JSON.parse(topExportQty);
		} catch (err) {
			console.log("Trade :topExportQty: " +err);
		}
	}
	let topExportVal = countryAnswers.answerKeyValues['top_exports_value'];
	let topExportValArr = [];
	if(topExportVal){
		try {
			topExportValArr = JSON.parse(topExportVal);
		} catch (err) {
			console.log("Trade :topExportVal: " +err);
		}
	}
	
	let WTOSourceRef = countryAnswers.answerKeyValues['wto_membership_date_sources'];
	let WTOYear = countryAnswers.answerKeyValues['wto_membership_date_year'];
	let WTONotes = countryAnswers.answerKeyValues['wto_membership_date_notes'];
	
	let partnerImportSourceRef = countryAnswers.answerKeyValues['top_trade_partners_imports_sources'];
	let partnerImportYear = countryAnswers.answerKeyValues['top_trade_partners_imports_year'];
	let partnerImportNotes = countryAnswers.answerKeyValues['top_trade_partners_imports_notes'];
	
	let partnerExportSourceRef = countryAnswers.answerKeyValues['top_trade_partners_exports_sources'];
	let partnerExportYear = countryAnswers.answerKeyValues['top_trade_partners_exports_year'];
	let partnerExportNotes = countryAnswers.answerKeyValues['top_trade_partners_exports_notes'];
	
	let importQtySourceRef = countryAnswers.answerKeyValues['top_imports_quantity_sources'];
	let importQtyYear = countryAnswers.answerKeyValues['top_imports_quantity_year'];
	let importQtyNotes = countryAnswers.answerKeyValues['top_imports_quantity_notes'];
	let importQtyUnit = countryAnswers.answerKeyValues['top_imports_quantity_unit'] || "Metric Tons";
	
	let importValSourceRef = countryAnswers.answerKeyValues['top_imports_value_sources'];
	let importValYear = countryAnswers.answerKeyValues['top_imports_value_year'];
	let importValNotes = countryAnswers.answerKeyValues['top_imports_value_notes'];
	
	let exportQtySourceRef = countryAnswers.answerKeyValues['top_exports_quantity_sources'];
	let exportQtyYear = countryAnswers.answerKeyValues['top_exports_quantity_year'];
	let exportQtyNotes = countryAnswers.answerKeyValues['top_exports_quantity_notes'];
	let exportQtyUnit = countryAnswers.answerKeyValues['top_exports_quantity_unit'] || "Metric Tons";
	
	let exportValSourceRef = countryAnswers.answerKeyValues['top_exports_value_sources'];
	let exportValYear = countryAnswers.answerKeyValues['top_exports_value_year'];
	let exportValNotes = countryAnswers.answerKeyValues['top_exports_value_notes'];
	
	let usDutySourceRef = countryAnswers.answerKeyValues['u_s_ad_cvd_duties_sources'];
	let usDutyYear = countryAnswers.answerKeyValues['u_s_ad_cvd_duties_year'];
	let usDutyNotes = countryAnswers.answerKeyValues['u_s_ad_cvd_duties_notes'];
	
	return(<div className="question-grouping" id="trade">
				<h2>Trade</h2>
				<h3>
					WTO membership
					{WTOYear ? 
					<small>&nbsp;({WTOYear})</small>
					: ""}
					{WTOSourceRef && WTOSourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+WTOSourceRef}>{WTOSourceRef}</a></small>
					:""}
				</h3>
				<p>{countryAnswers.answerKeyValues['wto_membership_date']}</p>
				{WTONotes ? 
				<p className="notes-info" style={{marginTop:"auto"}} >
					<em>{WTONotes}</em>
				</p>
				: ""}
				
				<div className="clearfix">
					<div style={{float:"left", width:"48%"}}>
						<div className="clearfix" style={{marginBottom: "20px"}}>
							<h3>
								Top Trade Partners for Imports
								{partnerImportYear ? 
								<small>&nbsp;({partnerImportYear})</small>
								: ""}
								{partnerImportSourceRef && partnerImportSourceRef > 0 ? 
								<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+partnerImportSourceRef}>{partnerImportSourceRef}</a></small>
								:""}
							</h3>
							<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
								<thead>
									<tr>
										<th>Partner</th>
										<th style={{width:"25%"}}>Value (1000 USD)</th>
									</tr>
								</thead>
								<tbody>
									<TradeField tradeArr={{tradeImportArr}} by={"Import"} />
								</tbody>
							</table>
							{partnerImportNotes ? 
							<p className="notes-info" style={{marginTop:"auto"}} >
								<em>{partnerImportNotes}</em>
							</p>
							: ""}
						</div>
					</div>
					<div style={{float:"right", width:"48%"}}>
						<div className="clearfix" style={{marginBottom: "20px"}}>
							<h3>
								Top Trade Partners for Exports
								{partnerExportYear ? 
								<small>&nbsp;({partnerExportYear})</small>
								: ""}
								{partnerExportSourceRef && partnerExportSourceRef > 0 ? 
								<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+partnerExportSourceRef}>{partnerExportSourceRef}</a></small>
								:""
								}
							</h3>
							<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
								<thead>
									<tr>
										<th>Partner</th>
										<th style={{width:"25%"}}>Value (1000 USD)</th>
									</tr>
								</thead>
								<tbody>
									<TradeField tradeArr={{tradeExportArr}} by={"Export"}/>
								</tbody>
							</table>
							{partnerExportNotes ? 
							<p className="notes-info" style={{marginTop:"auto"}} >
								<em>{partnerExportNotes}</em>
							</p>
							: ""}
						</div>
					</div>
				</div>
				<div className="clearfix">
					<div style={{float:"left", width:"48%"}}>
						<div className="clearfix" style={{marginBottom: "20px"}}>
							<h3>
								Top Imports by Quantity
								{importQtyYear ? 
								<small>&nbsp;({importQtyYear})</small>
								: ""}
								{importQtySourceRef && importQtySourceRef > 0 ? 
								<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+importQtySourceRef}>{importQtySourceRef}</a></small>
								:""}
							</h3>
							<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
								<thead>
									<tr>
									<th>Commodity</th>
									<th style={{width:"25%"}}>Quantity ({importQtyUnit})</th>
									</tr>
								</thead>
								<tbody>
									<TradeField tradeArr={{topImportQtyArr}} by={"ImportQty"}/>
								</tbody>
							</table>
							{importQtyNotes ? 
							<p className="notes-info" style={{marginTop:"auto"}} >
								<em>{importQtyNotes}</em>
							</p>
							: ""}
						</div>
					</div>
					<div style={{float:"right", width:"48%"}}>
						<div className="clearfix" style={{marginBottom: "20px"}}>
							<h3>
								Top Imports by Value
								{importValYear ? 
								<small>&nbsp;({importValYear})</small>
								: ""}
								{importValSourceRef && importValSourceRef > 0 ? 
								<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+importValSourceRef}>{importValSourceRef}</a></small>
								:""}
							</h3>
							<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
								<thead>
									<tr>
										<th>Commodity</th>
										<th style={{width:"25%"}}>Value (1000 USD)</th>
									</tr>
								</thead>
								<tbody>
									<TradeField tradeArr={{topImportValArr}} by={"ImportVal"}/>
								</tbody>
							</table>
							{importValNotes ? 
							<p className="notes-info" style={{marginTop:"auto"}} >
								<em>{importValNotes}</em>
							</p>
							: ""}
						</div>
					</div>
				</div>
				<div className="clearfix">
					<div style={{float:"left", width:"48%"}}>
						<div className="clearfix" style={{marginBottom: "20px"}}>
							<h3>
								Top Exports by Quantity
								{exportQtyYear ? 
								<small>&nbsp;({exportQtyYear})</small>
								: ""}
								{exportQtySourceRef && exportQtySourceRef > 0 ? 
								<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+exportQtySourceRef}>{exportQtySourceRef}</a></small>
								:""}
							</h3>
							<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
								<thead>
									<tr>
										<th>Commodity</th>
										<th style={{width:"25%"}}>Quantity ({exportQtyUnit})</th>
										</tr>
								</thead>
								<tbody>
									<TradeField tradeArr={{topExportQtyArr}} by={"ExportQty"}/>
								</tbody>
							</table>
							{exportQtyNotes ? 
							<p className="notes-info" style={{marginTop:"auto"}} >
								<em>{exportQtyNotes}</em>
							</p>
							: ""}
						</div>
					</div>
					<div style={{float:"right", width:"48%"}}>
						<div className="clearfix" style={{marginBottom: "20px"}}>
							<h3>
								Top Exports by Value
								{exportValYear ? 
								<small>&nbsp;({exportValYear})</small>
								: ""}
								{exportValSourceRef && exportValSourceRef > 0 ? 
								<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+exportValSourceRef}>{exportValSourceRef}</a></small>
								: ""}
							</h3>
							<table style={{width:"100%", float:"left", marginBottom:"20px"}}>
								<thead>
									<tr>
										<th>Commodity</th>
										<th style={{width:"25%"}}>Value (1000 USD)</th>
									</tr>
								</thead>
								<tbody>
									<TradeField tradeArr={{topExportValArr}} by={"ExportVal"}/>
								</tbody>
							</table>
							{exportValNotes ? 
							<p className="notes-info" style={{marginTop:"auto"}} >
								<em>{exportValNotes}</em>
							</p>
							: ""}
						</div>
					</div>
				</div>
				<h3>
					U.S. AD / CVD duties
					{usDutyYear ? 
					<small>&nbsp;({usDutyYear})</small>
					: ""}
					{usDutySourceRef && usDutySourceRef > 0 ? 
					<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+usDutySourceRef}>{usDutySourceRef}</a></small>
					:""}
				</h3>
				<p>{countryAnswers.answerKeyValues['u_s_ad_cvd_duties']}</p>
				{usDutyNotes ? 
				<p className="notes-info" style={{marginTop:"auto"}} >
					<em>{usDutyNotes}</em>
				</p>
				: ""}

			</div>);
}
export default Trade;